module.exports = _.some;